// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"117":"37759565","672":"c210c951","842":"cba7378e"}[chunkId] + ".chunk.js";
};